import initialstate from '../initialstate';

import {HttpStatusCodes} from '../../util/uiconstants';
import normalizeReconciliationsData from './normalizers/normalizeReconciliationsData';

import {
	CLEAR_SELECTED_RECONCILIATION,
	GET_RECONCILIATION_ACCOUNTS,
	GET_RECONCILIATION_RISKS,
	GET_ALL_RECONCILIATIONS,
	UPDATE_RECONCILIATION_ACCOUNT,
	UPDATE_RECONCILIATION_RISK,
	UPDATE_GROUP_COMPONENT_ACCOUNT,
	UPDATE_GROUP_COMPONENT_RISK
} from '../../actions/actiontypes';
import normalizeSelectedAccounts from './normalizers/normalizeSelectedAccounts';
import normalizeSelectedRisks from './normalizers/normalizeSelectedRisks';
import updateGroupComponentAccount from './GroupComponentAccount/updateGroupComponentAccount';
import updateGroupComponentRisk from './GroupComponentRisk/updateGroupComponentRisk';
import normalizeUpdatedEntityList from './normalizers/normalizeUpdatedEntityList';

export const reconciliationsReducer = (state = initialstate.reconciliations, action) => {
	switch (action.type) {
		case GET_ALL_RECONCILIATIONS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const {data = [], lastRefreshed} = action?.responseObj?.data;
				const displayedEntitiesIds = action?.entities?.filter((e) => e.isEnabled && e.checked).map((e) => e.entityId);
				return {
					...state,
					lastRefreshed,
					data: normalizeReconciliationsData(data, action.primaryEngagementId)?.filter((e) =>
						displayedEntitiesIds.includes(e.componentId)
					)
				};
			}
			if (action?.primaryEngagementId === undefined) {
				return {
					...state,
					data: []
				};
			}
			return {
				...state,
				lastRefreshed: '',
				data: []
			};
		}
		case CLEAR_SELECTED_RECONCILIATION: {
			return {...state, selected: {...initialstate.reconciliations.selected}};
		}
		case GET_RECONCILIATION_ACCOUNTS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const {data = null} = action?.responseObj;

				if (data === null) return {...state};

				const {
					componentName,
					engagementId,
					componentId,
					primaryAccounts,
					componentAccounts,
					engagementDescription
				} = data;

				return {
					...state,
					selected: {
						...state.selected,
						componentName,
						engagementId,
						engagementDescription,
						componentId,
						primaryAccounts: normalizeSelectedAccounts(primaryAccounts),
						componentAccounts: normalizeSelectedAccounts(componentAccounts)
					}
				};
			}
			return {...state};
		}
		case GET_RECONCILIATION_RISKS: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const {data = null} = action?.responseObj;

				if (data === null) return {...state};

				const {componentName, engagementId, componentId, primaryRisks = [], componentRisks = []} = data;

				return {
					...state,
					selected: {
						...state.selected,
						componentName,
						engagementId,
						componentId,
						primaryRisks: normalizeSelectedRisks(primaryRisks),
						componentRisks: normalizeSelectedRisks(componentRisks)
					}
				};
			}
			return {...state};
		}
		case UPDATE_RECONCILIATION_ACCOUNT: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const data = action?.responseObj?.data;
				if (data === null) return {...state};

				return {
					...state,
					selected: {
						...state.selected,
						primaryAccounts: [
							...normalizeUpdatedEntityList(state.selected.primaryAccounts, data?.primaryAccounts, 'accountId')
						],
						componentAccounts: [
							...normalizeUpdatedEntityList(state.selected.componentAccounts, data?.componentAccounts, 'accountId')
						]
					}
				};
			}
			return {...state};
		}
		case UPDATE_RECONCILIATION_RISK: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const {data = null} = action?.responseObj;
				if (data === null) return {...state};

				return {
					...state,
					selected: {
						...state.selected,
						primaryRisks: normalizeUpdatedEntityList(state.selected.primaryRisks, data?.primaryRisks, 'riskId'),
						componentRisks: normalizeUpdatedEntityList(state.selected.componentRisks, data?.componentRisks, 'riskId')
					}
				};
			}
			return {...state};
		}
		case UPDATE_GROUP_COMPONENT_ACCOUNT: {
			// updates rationale
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const data = action?.responseObj?.data;

				if (data === null) return {...state};

				return {
					...state,
					selected: {
						...state.selected,
						primaryAccounts: updateGroupComponentAccount(state.selected.primaryAccounts, action.response)
					}
				};
			}
			return {...state};
		}
		case UPDATE_GROUP_COMPONENT_RISK: {
			// updates rationale
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				const data = action?.responseObj?.data;

				if (data === null) return {...state};

				return {
					...state,
					selected: {
						...state.selected,
						primaryRisks: updateGroupComponentRisk(state.selected.primaryRisks, action.response)
					}
				};
			}
			return {...state};
		}
		default: {
			return state;
		}
	}
};
